import {ReactNode} from 'react'

export const ServiceRequestBody = ({children, className = ''}: { children: ReactNode, className?: string }) => {
    return <div className={'service-request-form-body ' + className}>
        {children}
    </div>
}